import { render, staticRenderFns } from "./Target.Detail.vue?vue&type=template&id=9ca7d4d8&"
import script from "./Target.Detail.vue?vue&type=script&lang=js&"
export * from "./Target.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports